export type TruncateProps = {
  // Nullable on purpose: this is a public component fed API-sourced strings (e.g. emails), which the
  // repo's API conventions allow to come back null/absent. A bare `string` wouldn't stop an `any`-typed
  // payload from passing null through and crashing on `.length`.
  text: string | null | undefined;
  maxLength: number;
  truncateEnding: string;
};

export default function Truncate({ text, maxLength, truncateEnding }: TruncateProps) {
  const safeText = text ?? '';

  const truncated = safeText.length > maxLength ? `${safeText.substring(0, maxLength)}${truncateEnding}` : safeText;

  return (
    <div className="email">
      <span>{truncated}</span>
    </div>
  );
}
